export default {
  signIn: 'Giri\u015f Yap',
  signOut: '\u00c7\u0131k\u0131\u015f Yap',
  points: 'puan',
  hyattSignInButton: "World of Hyatt'a giri\u015f yap",
};
